/* eslint-disable indent */
import { exportToExcel } from '@src/main/shared/utils/exportToExcel';
import { exportToPdf } from '@src/main/shared/utils/exportToPdf';
import { TFunction } from 'i18next';

export const createExportHandlers = <T>(
  data: T[],
  normalizeFn: (item: T, t: TFunction) => Record<string, string>,
  fileNamePrefix: string,
  t: TFunction,
) => ({
  onExportExcel: () => {
    const normalizedData = data.map((item) => normalizeFn(item, t));
    return exportToExcel(normalizedData, fileNamePrefix);
  },
  onExportPdf: () => {
    const normalizedData = data.map((item) => normalizeFn(item, t));
    return exportToPdf(normalizedData, fileNamePrefix);
  },
});
